import {Button, LinkButton, Tooltip} from '@primer/react'

import type {ConflictMergeConditionPayload} from '../../../page-data/payloads/merge-box'
import {ResolveConflictsAgentMenu} from './ResolveConflictsAgentMenu'
import type {ConflictsSectionStatuses} from '../../../types'

/**
 *
 * Renders the "Resolve conflicts" link button and handles the inactive state if the viewer cannot resolve conflicts in the web.
 */
export function ResolveConflictsButton({
  conflictsWebEditorPath,
  conflictsState,
  onError,
  showAgentOption,
  webEditorConflictResolution,
}: {
  conflictsWebEditorPath: string
  conflictsState: ConflictsSectionStatuses
  onError: (message: string) => void
  showAgentOption: boolean
  webEditorConflictResolution: ConflictMergeConditionPayload['webEditorConflictResolution']
}) {
  if (conflictsState !== 'HAS_CONFLICTS') return null
  if (!webEditorConflictResolution) return null

  if (
    !webEditorConflictResolution.viewerCanResolve &&
    (!showAgentOption || webEditorConflictResolution.viewerCannotResolve?.reason !== 'TOO_COMPLEX')
  ) {
    return (
      <Tooltip direction="nw" text={webEditorConflictResolution.viewerCannotResolve?.message || ''}>
        <Button inactive>Resolve conflicts</Button>
      </Tooltip>
    )
  }

  if (showAgentOption) {
    return (
      <ResolveConflictsAgentMenu
        conflictsWebEditorPath={conflictsWebEditorPath}
        onError={onError}
        webEditorConflictResolution={webEditorConflictResolution}
      />
    )
  }

  return <LinkButton href={conflictsWebEditorPath}>Resolve conflicts</LinkButton>
}
